export const PVI_NO_STYLES_CLASSNAME = 'pvi-no-styles';
